import h from 'react-hyperscript';
import { Button } from 'reactstrap';

const onClick = () => {
  console.error('Not implemented!'); // eslint-disable-line no-console
};

export default () =>
  h('.card.border-primary', [
    h('.card-header', [h('h4', '[ Title ]')]),
    h('.card-block', [
      h(
        '.card-body',
        'Enim pariatur sed voluptate est officia se labore, nostrud et culpa, nam summis legam malis appellat. A sunt minim tamen offendit, de ipsum voluptate appellat. Aut dolor arbitror.',
      ),
      h('br'),
      h('.text-center', [h(Button, { color: 'primary', onClick }, '[Call to Action]')]),
      h('br'),
      h('.text-center', [h('b', '[Footer msg]')]),
    ]),
  ]);



// WEBPACK FOOTER //
// ./src/components/Card/CardDefault.js